module.exports = __webpack_public_path__ + "media/react/components/Notifications/Notification/assets/trash_bottom-cf9fc8e15b1cf010fc3d869f0e9f69aa.svg";